// extracted by mini-css-extract-plugin
export default {"root":"SubmittedTableHeader_root__Dp5CI","heading":"SubmittedTableHeader_heading__CT7i5"};